import script from "./AudioRecorder.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioRecorder.vue?vue&type=script&setup=true&lang=js"

import "./AudioRecorder.vue?vue&type=style&index=0&id=7f5fb476&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f5fb476"]])

export default __exports__